import React from "react";
import { Badge, BadgeProps, Box } from "@mantine/core";

export interface CustomBadgeProps extends BadgeProps {
  label: string | React.ReactNode;
  withDot?: boolean; // Tùy chọn hiển thị dấu chấm trạng thái
}

const CustomBadge: React.FC<CustomBadgeProps> = ({
  label,
  withDot = false,
  color,
  variant = "light", // 'light' thường đẹp nhất cho các dashboard
  ...props
}) => {
  // Nút chấm tròn (Dot) kế thừa màu chữ (currentColor) của Badge
  const dotSection = withDot ? (
    <Box w={6} h={6} bg="currentColor" style={{ borderRadius: "50%" }} mr={4} />
  ) : undefined;

  return (
    <Badge
      color={color}
      variant={variant}
      leftSection={dotSection}
      style={{ textTransform: "none" }} // Tắt viết hoa toàn bộ mặc định của Mantine nếu muốn
      {...props}
    >
      {label}
    </Badge>
  );
};

export default CustomBadge;
